<template>
  <span class="heim-icon">
    <i></i>
  </span>
</template>

<script>
export default {
  name: "heim-icon",
  props: {
    size: {
      type: String,
      default: "24"
    },
    icon: {
      type: String,
      default: ""
    }
  },
  mounted: function() {
    const iconset = document.body.querySelector("#iconset");
    let icon = iconset.querySelector("#" + this.icon);

    if (!icon) return;
    this.$el.querySelector("i").innerHTML = "";
    this._cloneIcon(icon);
  },
  methods: {
    _cloneIcon(icon) {
      let content = icon.cloneNode(true);
      /**
       * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/createElementNS
       */
      let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      // Add iron-icon class in order to add control over color
      svg.classList.add("iron-icon");
      icon.classList.add("iron-icon");
      let viewBox = content.getAttribute("viewBox") || "0 0 " + 24 + " " + 24;
      let cssText =
        "pointer-events: none; display: block; width: 100%; height: 100%;";
      svg.setAttribute("viewBox", viewBox);
      svg.setAttribute("preserveAspectRatio", "xMidYMid meet");
      svg.setAttribute("focusable", "false");
      svg.style.cssText = cssText;
      let clonedIcon = icon.cloneNode(true);
      svg.appendChild(clonedIcon);
      const i = this.$el.querySelector("i");

      i.style.height = this.size;
      i.style.width = this.size;

      i.appendChild(svg);
    }
  },
  watch: {
    size: function(size) {
      this.$el.querySelector("i").style.height = size;
      this.$el.querySelector("i").style.width = size;
    },
    icon: function() {
      const iconset = document.body.querySelector("#iconset");
      let icon = iconset.querySelector("#" + this.icon);

      if (!icon) return;
      this.$el.querySelector("i").innerHTML = "";
      this._cloneIcon(icon);
    }
  }
};
</script>

<style scoped>
.heim-icon {
  display: inline-block;
  width: 24px;
  height: 24px;
  margin: 0 5px;
  box-sizing: content-box;
  vertical-align: sub;
}
i {
  display: flex;
  justify-content: center;
  align-items: center;
  font-style: normal;
  height: 100%;
  width: 100%;
  min-width: 100%;
}
</style>
